export const E_WEEK_DAY_KEYS_TO_INDEX_MAP = {
  'sunday': 0,
  'monday': 1,
  'tuesday': 2,
  'wednesday': 3,
  'thursday': 4,
  'friday': 5,
  'saturday': 6,
  '0': 'sunday',
  '1': 'monday',
  '2': 'tuesday',
  '3': 'wednesday',
  '4': 'thursday',
  '5': 'friday',
  '6': 'saturday'
};

export const ISO_WEEKDAY_MAP = {
  monday: 1, tuesday: 2, wednesday: 3, thursday: 4, friday: 5, saturday: 6, sunday: 7,
  1: 'monday', 2: 'tuesday', 3: 'wednesday', 4: 'thursday', 5: 'friday', 6: 'saturday', 7: 'sunday'
};

export const OUTLET_SCHEDULE_TYPES = {
  WORKING_DAYS: 'workingDays',
  PICKUP_SCHEDULE: 'pickupSchedule'
};

export const OUTLET_FORMATTED_SCHEDULE_TYPES = {
  [OUTLET_SCHEDULE_TYPES.WORKING_DAYS]: 'formattedWorkingDays',
  [OUTLET_SCHEDULE_TYPES.PICKUP_SCHEDULE]: 'formattedPickupSchedule',
};

export const CAKES_OVERVIEW_PATH = '/order-cake/';

export const EMAIL_PATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PHONE_PATTERN = /^\+?[\d\s\(\)-]+$/;
export const DELIVERY_BEFORE_PRODUCTS_KEY = 'CIE_DELIVERY_BEFORE_PRODUCTS';

export enum ORDER_LINE_STATES {
  NEW = 'NEW',
  EDITED = 'EDITED',
  DELETED = 'DELETED'
}

export enum PAYMENT_INTENT_STATUSES {
  NEW = 'NEW',
  PAID = 'PAID',
  CANCELLED = 'CANCELLED'
}

export const ALLERGENS_STATES = {
  FREE: 'FREE',
  CONTAINS: 'CONTAINS',
  MIGHT_FREE: 'MIGHT_FREE',
};

export const TRACKING_TYPES = {
  PAGE_OPEN: 'PAGE_OPEN',
  CHECKOUT_STEP: 'CHECKOUT_STEP'
};

export enum ORDER_DELIVERY_METHODS {
  PICKUP = 'PICKUP',
  DELIVERY_TO_DOOR = 'DELIVERY',
  MAIL_DELIVERY = 'MAIL',
  GIFT_DELIVERY = 'GIFT',
  /**Order without delivery details at all.
   * Created from an order request whose form has deliveryDetailsRequired: false */
  NO_DELIVERY = 'NO_DELIVERY',
}

export enum ORDER_REQUEST_STATUS {
  PENDING = 'PENDING',
  OFFER_SENT = 'OFFER_SENT',
  CREATED = 'CREATED',
  EXPIRED = 'EXPIRED',
  OFFER_CANCELLED = 'OFFER_CANCELLED',
  REQUEST_DECLINED = 'REQUEST_DECLINED',
  CONFIRMED = 'CONFIRMED',
  ARCHIVED = 'ARCHIVED',
}

export const ASAP = 'ASAP';

export enum SPECIAL_USER_LOGIN_TYPES {
  FULL = 'FULL',
  USERNAME = 'USERNAME',
}

export enum PRIVATE_WEB_SHOP_TYPES {
  NORMAL = 'NORMAL',
  CUSTOM = 'CUSTOM'
}

export enum PROJECTS_LINKED_ROUTES {
  DEMO_PAGE = 'demo'
}

export enum REQUEST_QUESTION_TYPES {
  SHORT_ANSWER = 'SHORT_ANSWER',
  LONG_ANSWER = 'LONG_ANSWER',
  UPLOAD_IMAGE = 'UPLOAD_IMAGE',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  DATE_AND_TIME = 'DATE_AND_TIME',
  INTEGRATED_PRODUCT = 'INTEGRATED_PRODUCT',
  REQUESTED_PRODUCT = 'REQUESTED_PRODUCT',
}

export enum ORDER_REQUEST_DELIVERY_STATUS {
  WAITING_DELIVERY_INFO = 'WAITING_DELIVERY_INFO',
  CONFIRMED = 'CONFIRMED'
}

export enum SELLER_TYPE {
  BAKERY = 'BAKERY',
  CATERING = 'CATERING',
}
